webpackJsonp([209350517766756],{

/***/ 409:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Blog by Peter Dol","subtitle":"A blog about .net core and full stack web development.","copyright":"© All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"},{"label":"Contact me","path":"/contact/"}],"author":{"name":"Peter Dol","email":"peterdol@gmail.com","github":"peterdol"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/generate-unique-secure-short-ids-with-dotnet","categorySlug":"/categories/security/"},"frontmatter":{"title":"How to generate secure short id's","date":"2018-06-06T17:40:32.169Z","category":"Security","description":"The eTender REST API generates unique reservation codes after a client creates a reservation. This reservation code alone is enough to cancel or update a reservation, so it should be unique and impossible to guess or tamper with using a brute force attack. In this blog post I describe how we generate these id’s."}}}]}},"pathContext":{"tag":"Security"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-security-d12ffda2454386e7e44a.js